import React, { useEffect } from 'react';

const DEFAULT_WIDGET_SRC = 'https://app.getgolfmarshal.com/widget/mg2-tee.js';
/** Production API used by the widget’s Strategy 1 — avoids Failed to fetch when mg2 isn’t running on :5000 */
const DEFAULT_MG2_API_URL = 'https://app.getgolfmarshal.com/api';

function TeeSheetDemo() {
  useEffect(() => {
    // Widget reads window.ENV.API_URL first (see mg2 widget-modern.js). Without this, loading
    // mg2-tee.js from localhost:5000 makes all tee-time requests hit :5000 — if the backend
    // isn’t running you get TypeError: Failed to fetch (connection refused), not a CORS JSON error.
    window.ENV = window.ENV || {};
    window.ENV.API_URL = process.env.REACT_APP_MG2_API_URL || DEFAULT_MG2_API_URL;

    // Strict Mode mounts twice; a second load of mg2-tee.js calls customElements.define
    // again and throws. That error runs in a cross-origin script, so React only shows
    // "Script error." Skip if the element is already defined or a loader tag exists.
    if (customElements.get('mg2-tee-booker')) return;
    if (document.querySelector('script[src*="mg2-tee.js"]')) return;

    const script = document.createElement('script');
    // Use REACT_APP_MG2_WIDGET_URL (e.g. http://localhost:5000/widget/mg2-tee.js) to test widget changes before deploy
    script.src = process.env.REACT_APP_MG2_WIDGET_URL || DEFAULT_WIDGET_SRC;
    script.async = true;
    script.setAttribute('data-t', '680231bed87c5cc321656af7');
    script.setAttribute('data-k', 'gm_6GhtVmV0TgNrc2Y7ER4-tw');
    document.body.appendChild(script);
  }, []);

  return (
    <div className="container mx-auto px-4 py-6">
      <mg2-tee-booker data-date="2026-04-07" data-allow-past="true" />
    </div>
  );
}

export default TeeSheetDemo;


